var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.424 12.78h7.405L7.73 4H1.03l5.853 5.092A9.348 9.348 0 0 0 1 17.842c.03 5.152 4.244 9.337 9.424 9.337h7.405l-5.035-4.39h-2.37a4.984 4.984 0 0 1-5.006-5.006 5.002 5.002 0 0 1 5.004-5.004zm11.181 5.59h-7.404l10.098 8.75h6.673l-5.853-5.062c3.57-1.434 5.912-4.888 5.883-8.722 0-5.18-4.215-9.365-9.395-9.335h-7.404l5.064 4.39h2.37a4.953 4.953 0 0 1 4.976 4.976 5.002 5.002 0 0 1-5.005 5.004z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcr);
export default __webpack_public_path__ + "static/media/DCR.504916d99140b0ea59a9dd8808bf8ea8.svg";
export { ForwardRef as ReactComponent };